import Vue from 'vue'
import request from '@/services/request'
import api from '@/services/api'
import utils from '@/services/utils/config'
import Cookies from 'js-cookie'
import { curEnvConfigAppInfoDict } from '@/services/microFeUtil/config'
import * as authBj from '@/services/utils/modules/authBj'
import apiErpLogin from '@/services/apiErp/modules/login'

const state = {
  account: '',
  fullname: '',
  shopName: '',
  platformIds: [],
  initBtnShow: false, // 初始化店铺按钮是否显示
  permissionMenus: [], // 深圳菜单权限
  bjMenuList: [], // 北京菜单权限
  isShopAuth: 1,
  loginPageResetCount: 1, // 改变的时候, 登录页面需要重置状态
  userInfoAfterLogin: {}, // 登录接口返回的用户数据
  sidType: 1, // 租户类型 0-免费版 1-正式版 2-体验版
  overTime: '', // 免费版过期时间
}

const mutations = {
  SET_USER_INFO_AFTER_LOGIN: (state, data) => {
    state.userInfoAfterLogin = data
  },
  SET_ACCOUNT: (state, data) => {
    if (!data) {
      state.sidType = 1
    } else {
      const { account, operatorName, sid, platformIds, isShopAuth, sidType, overTime } = data
      state.account = account
      state.fullname = operatorName
      state.shopName = sid
      state.platformIds = platformIds
      state.isShopAuth = isShopAuth
      state.sidType = sidType === undefined ? 1 : sidType
      state.overTime = overTime || ''
    }
  },
  SET_MENU: (state, permissionMenus) => {
    state.permissionMenus = permissionMenus
  },
  SET_BJ_MENULIST: (state, data) => {
    state.bjMenuList = data
  },
  SET_INIT_BTN_SHOW: (state, data) => {
    state.initBtnShow = data
  },
  INCREASE_LOGIN_PAGE_RESET_COUNT: (state, data) => {
    state.loginPageResetCount += 1
  },
}

const actions = {
  // 登录
  login({ commit }, { userInfo, type }) {
    return new Promise((resolve, reject) => {
      // 让erp登录成功
      authBj.setToken(userInfo.token)
      authBj.setPublicToken(userInfo.token)
      authBj.setShopNoticeVisible(1)

      // 让kj登录成功
      window.alreadySetRoute = false
      Vue.ls.set('sid', userInfo.sid)
      Vue.ls.set('account', userInfo.account)
      Vue.ls.set('operatorName', userInfo.operatorName)
      Vue.ls.set('gylLoginData', userInfo)
      utils.setToken(userInfo.token, type)
      commit('SET_USER_INFO_AFTER_LOGIN', userInfo)
      commit('map/REMOVE_MAP', {}, { root: true })
      commit('pageTag/SET_PAGE_TAGS_BY_USER', {}, { root: true })
      resolve()
    })
  },

  // 退出登录
  logout(ctx, { type }) {
    const { commit, state, dispatch } = ctx
    return new Promise((resolve, reject) => {
      // 删除北京erp token
      authBj.removeToken()
      authBj.removePublicToken()

      // sz bi登出逻辑
      const tokenObj = utils.getToken()
      if (type === 'auto' || tokenObj?.xFrom !== 1) {
        clearUserData(commit, ctx)
        resolve(tokenObj.xFrom)
      } else {
        request(api.login.logout).then(response => {
          clearUserData(commit, ctx)
          resolve(tokenObj.xFrom)
        }).catch(error => {
          reject(error)
        })
      }
    })
  },
  // 获取用户信息
  getUserInfo({ commit, state, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      apiErpLogin.getUserInfo().then(response => {
        const { code, data } = response
        if ([40022, 40013].includes(code)) {
          commit('SET_ACCOUNT', data)
          resolve(data)
        }
        if (code === 200) {
          Vue.ls.set('sid', data.sid)
          Vue.ls.set('account', data.account)
          commit('SET_ACCOUNT', data)
          resolve(data)
        } else {
          reject(new Error())
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取北京菜单
  getBjMenuList({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      const reqData = {
        domain: curEnvConfigAppInfoDict.erp.syncMenuDomain,
        biDomain: curEnvConfigAppInfoDict.bi.syncMenuDomain,
      }

      // request(api.login.syncMenuRight, reqData, {
      //   ignoreCodeHandler: true, // 忽略 ajax拦截器 里面的code处理逻辑, token失效的时候静默到登录页
      // })
      apiErpLogin.acquireSysMenuByRights(reqData, {
        ignoreCodeHandler: true, // 忽略 ajax拦截器 里面的code处理逻辑, token失效的时候静默到登录页
      })
        .then(response => {
          const { code, data } = response
          if (code === 200) {
            // const isGrayUser = ['ywmy'].includes(Vue.$ls.get('sid')) // 特殊客户隐藏虚拟仓菜单
            // if (isGrayUser) {
            //   const menu = data.map((item) => {
            //     return {
            //       ...item,
            //       children: item.children.filter(child => child.title !== '虚拟仓')
            //     }
            //   })
            //   commit('SET_BJ_MENULIST', menu)
            //   resolve(menu)
            //   return
            // }
            commit('SET_BJ_MENULIST', data)
            resolve(data)
          } else {
            reject(new Error())
          }
        }).catch(error => {
          reject(error)
        })
    })
  },
  // 获取初始化按钮是否显示
  getInitBtnShow({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      request(api.mallAuth.listSyncShop).then(response => {
        const { code, data } = response
        if (code === 200) {
          if (data?.length > 0) {
            commit('SET_INIT_BTN_SHOW', true)
          }
          resolve(data)
        } else {
          reject(new Error())
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  increaseLoginPageResetCount({ commit, state, dispatch }) {
    commit('INCREASE_LOGIN_PAGE_RESET_COUNT')
  },
}

function clearUserData(commit, actionCtx) {
  window.alreadySetRoute = false
  // Vue.ls.remove('sid')
  // Vue.ls.remove('account')
  Cookies.remove('noticeVisibleBi', { domain: '.' + document.domain.split('.').slice(-2).join('.') })
  utils.removeToken()
  commit('map/REMOVE_MAP', {}, { root: true })
  actionCtx.dispatch('pageTag/logout', {}, { root: true })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
